// Angular import
import { Component, EventEmitter, HostListener, Output, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavigationComponent {
  // public props
  @Output() NavCollapsedMob = new EventEmitter();
  @Output() NavCollapse = new EventEmitter<void>();
  @Input() navCollapsed = false;
  navCollapsedMob = window.innerWidth;
  windowWidth: number;

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.windowWidth = event.target.innerWidth;
    this.navCollapseMob();
  }

  // public method
  navCollapseMob() {
    if (this.windowWidth < 1025) {
      this.NavCollapsedMob.emit();
    }
  }
}
